module.exports = __webpack_public_path__ + "static/media/calandar-off.cfc83621.svg";